import { state } from "@angular/animations";
import { createFeatureSelector, createSelector } from "@ngrx/store";
import { KnBrSalesOrgState, KN_BR_SALES_ORG_FEATURE } from "./kn-br-salesorg.state";


export const getSalesOrgState = createFeatureSelector<KnBrSalesOrgState>(KN_BR_SALES_ORG_FEATURE);

export const getSalesOrg = createSelector(getSalesOrgState, (state: KnBrSalesOrgState) => state)